import { 
  SET_USER_DATA, 
  SET_SUBSCRIPTION_PLANS
} from '../types';

const initialStore = {
  amountOfDays: 90,
	userData: {
    userId: null,
    email: null
  },
  subscriptionDataPopup: {}
};

const stripeReducer = (state = initialStore, action) => {
	switch(action.type) {
		case SET_USER_DATA: {
			return {...state, userData: action.payload}
    }
    case SET_SUBSCRIPTION_PLANS: {
			return {...state, subscriptionDataPopup: {...action.payload} }
		}
		
		default : return state;
	};
};

export default stripeReducer;
